@if (mode === 'renderer') {
  <div
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft
    }"
  >
    @if (element.fields.title) {
      <h3>{{ element.fields.title | translate }}</h3>
    }

    @if (loading) {
      <div class="text-center p-3">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    } @else if (items.length === 0) {
      <p class="text-muted">{{ (isQuotes ? 'NO_SAVED_QUOTES' : 'NO_SAVED_CARTS') | translate }}</p>
    } @else {
      <div class="saved-carts-list">
        @for (item of items; track item.id) {
          <div class="saved-cart-item d-flex align-items-center justify-content-between p-3 mb-2 border rounded">
            <div>
              <div class="fw-bold">{{ item.name }}</div>
              <small class="text-muted">
                {{ item.creationDate | date : 'yyyy-MM-dd' }}
                @if (item.username) {
                  &nbsp;&bull;&nbsp;{{ item.username }}
                }
              </small>
            </div>
            <button class="btn btn-primary btn-sm" (click)="loadItem(item)">
              {{ (isQuotes ? 'LOAD_QUOTE' : 'LOAD_CART') | translate }}
            </button>
          </div>
        }
      </div>
      <div class="text-end mt-2">
        <a class="btn btn-link btn-sm" (click)="navigateToList()">{{ element.fields.listLinkText | translate }}</a>
      </div>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Content</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Title'"
                [(ngModel)]="element.fields.title"
              ></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Link text'"
                [(ngModel)]="element.fields.listLinkText"
              ></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Link route'"
                [(ngModel)]="element.fields.listRoute"
              ></lib-gung-text-input>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Styles</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <lib-gung-accordion [closeOthers]="false">
            <lib-gung-accordion-item [collapsed]="true">
              <ng-template libGungAccordionHeader>General Settings</ng-template>
              <ng-template libGungAccordionBody>
                <lib-dynamic-page-element-margin-padding
                  [(marginTop)]="element.fields.marginTop"
                  [(marginRight)]="element.fields.marginRight"
                  [(marginBottom)]="element.fields.marginBottom"
                  [(marginLeft)]="element.fields.marginLeft"
                  [(paddingTop)]="element.fields.paddingTop"
                  [(paddingRight)]="element.fields.paddingRight"
                  [(paddingBottom)]="element.fields.paddingBottom"
                  [(paddingLeft)]="element.fields.paddingLeft"
                ></lib-dynamic-page-element-margin-padding>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-solid" [class.fa-cart-shopping]="!isQuotes" [class.fa-file-invoice-dollar]="isQuotes"></i>
  </div>
}
